module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "input",
    staticClass: "form-control",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.currentValue) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v(_vm._s(_vm.currentValue))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad1a29d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/FieldEditable.vue
// module id = 722
// module chunks = 1